import { createSelector } from "reselect";
import * as R from "ramda";

import { getters } from "ui-kit/DoubleSelect";

export const getSelectedSubOptions = createSelector(
  getters.selectedSubOptions,
  R.reduce((acc, id) => ({ ...acc, [id]: 1 }), {})
);
